import React from"react";var Collapse=function(_ref){var children=_ref.children,isOpen=_ref.isOpen,dataHook=_ref.dataHook;return React.createElement("div",{"data-hook":dataHook},isOpen&&children)};export{Collapse as default};
//# sourceMappingURL=Collapse.js.map
